import { useMutation } from "react-query";
import { addCarrier } from "../../../../actions/CarrierAgreementMgmt/Carrier";
const useAddCarrier = () => {
  //Add new carrier function
  return useMutation(addCarrier);
};
export default useAddCarrier;
